"use client";

import { Box, Flex, Text } from "@chakra-ui/react";
import { useTranslations } from "next-intl";

export function LandingTicker() {
  const t = useTranslations("landing.redesign.ticker");
  const items = t.raw("items") as string[];

  const doubled = [...items, ...items];

  return (
    <Box
      as="section"
      aria-label="Product highlights"
      bg="neutral.900"
      py={3.5}
      overflow="hidden"
    >
      <Box className="landing-ticker-track">
        <Flex as="span" className="landing-ticker-inner" gap={12}>
          {doubled.map((label, i) => (
            <Flex
              key={`${label}-${i}`}
              as="span"
              align="center"
              gap={3}
              whiteSpace="nowrap"
            >
              <Text
                as="span"
                fontFamily="var(--font-landing-syne), sans-serif"
                fontSize="13px"
                fontWeight="600"
                color="white"
              >
                {label}
              </Text>
              <Text as="span" color="primary.300" fontSize="18px" aria-hidden>
                ✦
              </Text>
            </Flex>
          ))}
        </Flex>
      </Box>
    </Box>
  );
}
